export default __webpack_public_path__ + "media/pro/prices-separator-f4ae44b8.svg";